export const cognitoConfig = {
  region: process.env.REACT_APP_COGNITO_REGION || 'us-west-2',
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-west-2_WPbZgCgd2',
  userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || 'tpm9rg953blkdsbm30a34eka2',
  userPoolClientSecret: process.env.REACT_APP_COGNITO_CLIENT_SECRET, // Add your client secret here

  // Auth configuration
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  cookieStorage: {
    domain: process.env.NODE_ENV === 'production' ? '.syncmysquad.com' : 'localhost',
    secure: process.env.NODE_ENV === 'production',
    path: '/',
    expires: 365
  }
};